import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'grounding_in_real_life'

export default function GroundingInRealLifePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What grounds you in real life?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.groundingInRealLife.heading')}
      buttons={[
        {
          text: `🎧 ${t('pages.onboarding.groundingInRealLife.options.music')}`,
          value: 'Music A song can reset my whole mood',
          subtext: t('pages.onboarding.groundingInRealLife.subtexts.music'),
        },
        {
          text: `🌿 ${t('pages.onboarding.groundingInRealLife.options.nature')}`,
          value: 'Nature I breathe deeper outside',
          subtext: t('pages.onboarding.groundingInRealLife.subtexts.nature'),
        },
        {
          text: `📓 ${t('pages.onboarding.groundingInRealLife.options.journaling')}`,
          value: 'Journaling My thoughts make more sense on paper',
          subtext: t(
            'pages.onboarding.groundingInRealLife.subtexts.journaling',
          ),
        },
        {
          text: `🕯️ ${t('pages.onboarding.groundingInRealLife.options.rituals')}`,
          value: 'Rituals Candles, altars, intentions – all of it',
          subtext: t('pages.onboarding.groundingInRealLife.subtexts.rituals'),
        },
        {
          text: `🏃‍♂️ ${t('pages.onboarding.groundingInRealLife.options.movement')}`,
          value: 'Movement Running, dancing, stretching it out',
          subtext: t('pages.onboarding.groundingInRealLife.subtexts.movement'),
        },
        {
          text: `🪁 ${t('pages.onboarding.groundingInRealLife.options.somethingElse')}`,
          value: 'Something else The weird thing only I do (It counts)',
          subtext: t(
            'pages.onboarding.groundingInRealLife.subtexts.somethingElse',
          ),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
